import { Model as BaseModel } from 'vue-api-query'

export default class Model extends BaseModel {
    // define a base url for a REST API
    baseURL () {
        return process.env.VUE_APP_API_ROUTE
    }
    // implement a default request method 
    request (config) {
        return this.$http.request(config)
    }

    /**
     *
     */
    static async fetchDataTable(limit, page, sort, params = {}) {
        //
        try {
            //
            return await this
            		.include(this.includes)
                .limit(limit)
                .page(page)
                .orderBy(sort)
                .params(params)
                .get()
        } catch (error) {
            //
            //console.error( error )

            //
            return []
        }
    }
}